import React from 'react';
import { motion } from 'framer-motion';
import { Leaf } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-12 md:py-24 px-4 bg-cream-100 relative border-t border-amber-500/20" data-id="element-119">
      <div className="max-w-4xl mx-auto" data-id="element-120">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-8 md:mb-16" data-id="element-121">
          <h2 className="text-3xl md:text-4xl font-playfair font-bold text-forest-900 mb-4" data-id="element-122">
            El Problema Real
          </h2>
          <div className="flex justify-center items-center gap-4 text-amber-500" data-id="element-123">
            <div className="h-px w-12 bg-amber-500/40" data-id="element-124"></div>
            <Leaf size={20} data-id="element-125" />
            <div className="h-px w-12 bg-amber-500/40" data-id="element-126"></div>
          </div>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6 md:gap-12 items-center" data-id="element-127">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} className="space-y-6 text-lg font-lora text-ink-800 leading-relaxed" data-id="element-128">
            <p data-id="element-129">
              La mayoría de las personas creen que los remedios naturales
              "tardan mucho" o "son flojos". Y tienen razón, porque{' '}
              <strong className="text-forest-800" data-id="element-130">los preparan mal.</strong>
            </p>
            <p data-id="element-131">
              Si solo echas agua hirviendo a una planta, estás desperdiciando el
              90% de su poder curativo. Estás tomando agua con sabor, no
              medicina.
            </p>
            <p className="p-6 bg-cream-200 border-l-4 border-amber-500 rounded-r-md italic text-ink-900 shadow-sm" data-id="element-132">
              Mientras tanto, tu hígado sigue procesando fármacos sintéticos y
              tu bolsillo se vacía en la farmacia por problemas que podrías
              resolver con un trozo de jengibre o un clavo de olor.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative p-2 bg-white rounded-sm shadow-xl border border-cream-200 rotate-1 hover:rotate-0 transition-transform duration-500" data-id="element-133">
            <div className="absolute -inset-1 bg-gradient-to-tr from-amber-500/20 to-forest-800/20 blur-lg -z-10" data-id="element-134"></div>
            <div className="aspect-[4/3] bg-forest-900/5 rounded-sm flex items-center justify-center border border-forest-900/10 overflow-hidden" data-id="element-135">
              <img src="https://cdn.magicpatterns.com/uploads/frdUF1edGsDFGubbQdRc9g/heylloyd-image-1772577109972.png" alt="Mortero con especias y hierbas medicinales" className="w-full h-full object-cover opacity-90 mix-blend-multiply" data-id="element-136" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}